//* 답례품 단가표 페이지 전용 hook
//* 현재 판매중인 답례품(giftItem)의 판매가/원가/상조 수익금 조회 (백엔드 가공 데이터)

import { fetcher, useRecoilQuery } from '@shared/hooks/recoil-query';
import { useAuth } from '@shared/state/hooks/useAuth';

import {
  giftPriceTableDataAtom,
  giftPriceTableStatusAtom,
} from './giftPriceTable.atom';

/** 답례품 단가표 URL — bugoBrand 단위 판매중 giftItem (백엔드가 상조 수익금 계산) */
export const giftPriceTableUrl = (bugoRole: string, bugoBrandId?: string) =>
  `/${bugoRole}/gift-item/price-table?bugoBrand=${bugoBrandId ?? ''}`;

export const useGiftPriceTableHook = (bugoBrandId?: string) => {
  const { bugoRole } = useAuth();

  useRecoilQuery(
    giftPriceTableStatusAtom,
    giftPriceTableDataAtom,
    giftPriceTableUrl(bugoRole(), bugoBrandId),
    fetcher,
    !bugoBrandId, // bugoBrandId 없으면 비활성
  );
};
